import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Der er foretaget lovpligtig skadesrelateret miljøscreening med udgangspunkt i ejendommens alder samt gældende Affaldsbekendtgørelse og arbejdsmiljølovgivning. Screeningen omfatter bygningsdele, som vurderes at være omfattet af forestående skadesudbedring, og materialerne undersøges for indhold af specifikke og erfaringsmæssigt typiske miljø- og personskadelige stoffer. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Nærværende miljøscreening må derfor betragtes som repræsentativ for de overordnede affaldsmængder, og som vejledende i forhold til sikring af arbejdsmiljø i forbindelse med skadesudbedringen. Det kan dog ikke udelukkes, at der i forbindelse med renoveringsarbejdet opstår behov for supplerende analyser, samt løbende tilpasning af risikovurdering på stedet, til faktiske forhold, ligesom skjulte materialer ikke indgår i nærværende undersøgelse. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Der er så vidt muligt udtaget materialeprøver som er repræsentative for det pågældende materiale og affaldsfraktion. Prøver er udtaget i henhold til almindelig professionel skik, med blandt andet brug af engangsudstyr og handsker, samt emballering i alufolie. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", {
  style: {"margin-top":"48px"},
  class: "PDFSectionTitle js-section-headline"
}, "2. Vurdering og anbefaling", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "PDFRichText" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Materialer, der hører under flere bygningsdele, er typisk kun beskrevet én gang i den primære bygningsdel. "),
  /*#__PURE__*/_createElementVNode("p", null, " Hvor der er risiko for miljøproblematiske stoffer, er der udtaget en repræsentativ materialeprøve til analyse, eller der er foretaget en vurdering med udgangspunkt i en 'worst case' forekomst af miljøproblematiske stoffer. Eventuelle vurderinger er vejledende og er foretaget med udgangspunkt i forsigtighedsprincippet. "),
  /*#__PURE__*/_createElementVNode("p", null, " Der er ved hvert materiale en vejledende anbefaling for håndtering og bortskaffelse, samt anbefaling af eventuelle arbejdsmiljømæssige tiltag. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFFrontpage = _resolveComponent("PDFFrontpage")!
  const _component_PDFPage = _resolveComponent("PDFPage")!
  const _component_PDFComments = _resolveComponent("PDFComments")!
  const _component_PDFCategories = _resolveComponent("PDFCategories")!
  const _component_PDFPreview = _resolveComponent("PDFPreview")!

  return (_openBlock(), _createBlock(_component_PDFPreview, {
    key: _ctx.key,
    class: "DamageRelatedScreeningReport",
    "data-report-reference": _ctx.pdf.reference,
    referenceName: _ctx.pdf.reference,
    initFetch: _ctx.initiatePDFRequest,
    preview: _ctx.preview,
    onStatusChanged: _ctx.statusChanged
  }, {
    default: _withCtx(({ created, addAsPending, removeAsPending }) => [
      _createVNode(_component_PDFFrontpage, {
        context: _ctx.pdf.reference,
        createdTimestamp: created,
        title: _ctx.pdf.title,
        onVnodeBeforeMount: ($event: any) => (addAsPending(_ctx.pdf.reference, 'section')),
        onCompleted: ($event: any) => (removeAsPending(_ctx.pdf.reference, 'section'))
      }, null, 8, ["context", "createdTimestamp", "title", "onVnodeBeforeMount", "onCompleted"]),
      _createVNode(_component_PDFPage, {
        class: "PDFParadigmIntro",
        contentClasses: 'PDFRichText',
        context: _ctx.pdf.reference
      }, {
        sectionTitle: _withCtx(() => [
          _createTextVNode("1. " + _toDisplayString(_ctx.mixWB('INTRODUCTION')), 1)
        ]),
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }, 8, ["context"]),
      (_ctx.reportNotes)
        ? (_openBlock(), _createBlock(_component_PDFComments, {
            key: 0,
            section: 2,
            context: _ctx.pdf.reference,
            onVnodeBeforeMount: ($event: any) => (addAsPending(_ctx.pdf.reference, 'sections')),
            onCompleted: ($event: any) => (removeAsPending(_ctx.pdf.reference, 'sections'))
          }, null, 8, ["context", "onVnodeBeforeMount", "onCompleted"]))
        : _createCommentVNode("", true),
      _createVNode(_component_PDFCategories, {
        section: 2 + _ctx.reportNotes,
        context: _ctx.pdf.reference,
        onVnodeBeforeMount: ($event: any) => (addAsPending(_ctx.pdf.reference, 'sections')),
        onCompleted: ($event: any) => (removeAsPending(_ctx.pdf.reference, 'sections'))
      }, null, 8, ["section", "context", "onVnodeBeforeMount", "onCompleted"])
    ]),
    _: 1
  }, 8, ["data-report-reference", "referenceName", "initFetch", "preview", "onStatusChanged"]))
}